var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7508 5C12.7508 7.07107 11.0719 8.75 9.00082 8.75C6.92975 8.75 5.25082 7.07107 5.25082 5C5.25082 2.92893 6.92975 1.25 9.00082 1.25C11.0719 1.25 12.7508 2.92893 12.7508 5Z",
    stroke: "#001F68",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50195 19.1182C1.57226 15.0369 4.90269 11.75 9.00082 11.75C13.099 11.75 16.4295 15.0371 16.4997 19.1185C14.2169 20.166 11.6772 20.75 9.00114 20.75C6.32481 20.75 3.78491 20.1659 1.50195 19.1182Z",
    stroke: "#001F68",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.12efe25cc85adebf3a56b46c8ac87378.svg";
export { ForwardRef as ReactComponent };